import { render, staticRenderFns } from "./EditVideoSession.vue?vue&type=template&id=738c9020"
import script from "./EditVideoSession.vue?vue&type=script&lang=js"
export * from "./EditVideoSession.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports